import { createContext, useContext, useEffect, useMemo, useState } from 'react';

const CART_STORAGE_KEY = 'sunshine-tours-cart-v1';
const CartContext = createContext(null);

function readCart() {
  try {
    const value = window.localStorage.getItem(CART_STORAGE_KEY);
    const items = value ? JSON.parse(value) : [];
    return Array.isArray(items) ? items : [];
  } catch {
    return [];
  }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(readCart);

  useEffect(() => {
    try {
      window.localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(items));
    } catch {
      // The cart continues to work for this visit if storage is unavailable.
    }
  }, [items]);

  const value = useMemo(() => ({
    items,
    addItem: (booking) => setItems((current) => [...current, {
      ...booking,
      cartItemId: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    }]),
    updateItem: (cartItemId, updates) => setItems((current) => current.map((item) => (
      item.cartItemId === cartItemId ? { ...item, ...updates } : item
    ))),
    removeItem: (cartItemId) => setItems((current) => current.filter((item) => item.cartItemId !== cartItemId)),
    clearCart: () => setItems([]),
  }), [items]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  const context = useContext(CartContext);
  if (!context) throw new Error('useCart must be used within CartProvider');
  return context;
}
